<template>
  <div class="PermissionSelectDrawer">
    <el-drawer
      :visible.sync="drawerVisible"
      size="400px"
      :before-close="closeDrawer"
      destroyOnClose
      ref="drawer"
    >
      <div class="drawer-title" slot="title">
        <p>
          <span>授权管理</span>
          <i class="role-name-icon el-icon-arrow-right" v-if="role_name"></i>
          <span class="role-name" v-if="role_name">{{ role_name }}</span>
        </p>
      </div>
      <div class="drawer-content drawer-content-hasfooter">
        <el-table
          :data="tableData"
          row-key="id"
          border
          default-expand-all
          ref="multipleTable"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @select="handleSelect"
          @select-all="handleSelectAll"
          @selection-change="debounceHandleSelectionChange"
        >
          <el-table-column align="center" type="selection" width="100" />
          <el-table-column prop="name" label="权限" />
        </el-table>
      </div>
      <div class="drawer-footer">
        <el-button type="primary" @click="savePermission">保存</el-button>
        <el-button @click="closeDrawer">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { roleMenuList,  rolemenusave } from '@/page/system/api/role'
import { debounce } from "lodash";
export default {
  name: "PermissionSelectDrawer",
  props: ["visible", "data"],
  components: {},
  data() {
    return {
      role_id: "",
      role_name: "",
      drawerVisible: false,
      tableData: [],
      multipleSelection: [],
    };
  },
  watch: {
    visible(val) {
      this.drawerVisible = val;
    },
    data(val) {
      if (val) {
        this.role_id = val.id;
        this.role_name = val.name;
      }
      this.getPermission();
    },
  },
  created() {
    this.debounceHandleSelectionChange = debounce(this.handleSelectionChange);
  },
  mounted() {
    this.drawerVisible = this.visible;
    if (this.data) {
      this.role_id = this.data.id;
      this.role_name = this.data.name;
    }
  },
  methods: {
    // 获取权限
    getPermission() {
      roleMenuList({ id: this.role_id })
        .then((res) => {
          if (res.data.success) {
            this.tableData = res.data.data;
            this.$nextTick(() => {
              this.initTreeChecked();
            });
          }
        });
    },
    // 保存权限
    savePermission() {
      let menu_arr = [];

      this.multipleSelection.map((item) => {
        menu_arr.push(item.id);
      });
      rolemenusave({
          id: this.role_id,
          menus: menu_arr.join(","),
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "保存成功!",
            });
            //   localStorage.removeItem('permission');
            //   this.onGetPerssion()
            this.closeDrawer();
          }
        });
    },
    initTreeChecked() {
      this.tableData.forEach((item) => {
        if (item.checked) {
          this.$refs.multipleTable.toggleRowSelection(item, true);
        }
        this.trunNode(item);
      });
    },

    //递归设置节点选中
    trunNode(node) {
      var lists = node.children;
      if (lists && lists.length > 0) {
        for (var i = 0; i < lists.length; i++) {
          if (lists[i].checked) {
            this.$refs.multipleTable.toggleRowSelection(lists[i], true);
          }
          this.trunNode(lists[i]);
        }
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectAll(selection) {
      const isAllSelected = this.$refs.multipleTable.store.states.isAllSelected;
      var _handleSelectAll = (data) => {
        data.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item, isAllSelected);
          _handleSelectAll(item.children || []);
        });
      };
      _handleSelectAll(this.tableData);
    },
    handleSelect(selection, current) {
      // 判断selection中是否存在current,若是存在那么就代表是被勾选上了,若是不存在代表是取消勾选了
      const isChecked = !!selection.find((item) => item.id === current.id);
      // 如果当前项被取消勾选
      if (!isChecked) {
        // 那么其所有的后代也应该被取消勾选
        this.toggleCheckedChildrens(selection, current, false);
        // 那么若是所有的兄弟都被取消勾选的话,其祖先也应该被取消勾选
        this.uncheckedParents(selection, current);
      } else {
        // 如果当前项被勾选
        // 那么若同一组的元素都被勾选了,那么父元素将也被勾选,依次往上类推
        this.checkedParents(selection);
        // 那么其所有的后代都要被勾选
        this.toggleCheckedChildrens(selection, current, true);
      }
    },
    toggleCheckedChildrens(selection, item, isChecked) {
      var _toggleCheckedChildrens = (data) => {
        data.find((element) => {
          this.$refs.multipleTable.toggleRowSelection(element, isChecked);
          if (isChecked && !selection.find((item) => item.id === element.id)) {
            selection.push(element);
          } else if (
            !isChecked &&
            selection.find((item) => item.id === element.id)
          ) {
            for (let i = selection.length - 1; i >= 0; i--) {
              if (selection[i].id === element.id) {
                selection.splice(i, 1);
                break;
              }
            }
          }
          _toggleCheckedChildrens(element.children || []);
        });
      };
      _toggleCheckedChildrens(item.children || []);
    },
    checkedParents(selection) {
      var _checkedParents = (element) => {
        const children = element.children;
        if (children && children.length) {
          const anyChildrenChecked = children.some((child) => {
            return _checkedParents(child);
          });
          if (anyChildrenChecked) {
            this.$refs.multipleTable.toggleRowSelection(element, true);
            if (!selection.find((item) => item.id === element.id)) {
              selection.push(element);
            }
          }
        }
        return selection.find((item) => item.id === element.id);
      };
      this.tableData.forEach((element) => {
        _checkedParents(element);
      });
    },
    uncheckedParents(selection, item) {
      var _uncheckedParents = (element) => {
        const children = element.children;
        if (children && children.length) {
          const allChildrenUnChecked = children.every((child) => {
            return _uncheckedParents(child);
          });
          if (allChildrenUnChecked) {
            this.$refs.multipleTable.toggleRowSelection(element, false);
            for (let i = selection.length - 1; i >= 0; i--) {
              if (selection[i].id === element.id) {
                selection.splice(i, 1);
                break;
              }
            }
            return true;
          } else {
            return false;
          }
        }
        return selection.every((item) => item.id !== element.id);
      };
      this.tableData.forEach((element) => {
        _uncheckedParents(element);
      });
    },

    // 抽屉关闭操作
    closeDrawer() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.select-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;

  .select-list-item {
    margin: 5px 10px;
  }
}

.role-name-icon {
  font-size: 16px;
  margin: 0 5px;
  color: #aaa;
}

.role-name {
  font-size: 16px;
  line-height: 28px;
  color: #fff;
  cursor: default;
}

.el-drawer.rtl {
  overflow-y: scroll !important;
}
.drawer-footer {
  margin: 20px;
}

.drawer-content {
  .el-table {
    th {
      &.el-table__cell {
        background: #141C3A;
      }
    }
  }
}

:deep(.el-drawer__header) {
  .drawer-title {
    color: #fff;
  }
}
</style>
